
import React, { useEffect } from 'react'
import { useFieldArray } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';

export default function CustomItemsFields({ v }) {
    const { fields, append } = useFieldArray({
        control: v.control,
        name: v.items
    });

    useEffect(() => {
        if (fields?.length === 0) appendFieldArrayData()
    }, [])

    const appendFieldArrayData = () => {
        append({ ...v?.data?.fields })
    }


    const getOBJKeys = (obj) => obj ? Object.keys(obj) : null

    const getInputType = (f) => (f === "quantity" || f === "bales" || f === "pieces" || f === "sort" || f === "price_per_unit" || f === "real_price_per_unit") ? 'number' : 'text'

    const isRequired = (f) => (f === "description" || f === "weight") ? false : 'This field is required'

    const isDisabled = (f) => (f === "quantity" || f === "quantity_type")

    return (
        <fieldset className={`border border-solid border-gray-300 px-2 py-1 rounded-md ${v.data?.className}`}>
            <legend className={`text-base text-black font-semibold amiriB ${v.className}`}>Items</legend>
            <div className='overflow-auto grid grid-cols-1  '>
                <table className=' w-full border-separate border-spacing-2 border-slate-400'>
                    {/*   <thead>
                        <tr className='amiriB'>
                            {v.data?.head?.map((h, i) => (<th key={i}>{h}</th>))}
                            {fields.length > 1 && <td></td>}
                        </tr>
                    </thead> */}
                    <tbody>
                        {fields?.map((o, i) => {
                            return (

                                <tr key={i} className="relative">

                                    {getOBJKeys(v?.data?.fields)?.map((f, j) => {
                                        return <td key={j} >

                                            {f !== 'category' ? <AInput v={{
                                                register: v?.register, errors: v?.errors, control: v?.control,
                                                data: { label: v.data?.head[j], name: `items.${i}.${f}`, isDisabled: isDisabled(f), type: getInputType(f), required: isRequired(f) }
                                            }} />

                                                : <ASelect v={{
                                                    errors: v?.errors, control: v?.control,
                                                    data: { label: v.data?.head[j], name: `items.${i}.${f}`, type: 'select', options: [o.category], isDisabled: true, required: 'This field is required' }
                                                }} />
                                            }
                                        </td>
                                    })}
                                    {/*     {i > 0 && <td className='w-[4%]' onClick={() => remove(i)}> <Button className='btn1 p-1 !bg-red-900 rounded-full'  ><AIcon name="close" size={15} /> </Button> </td>} */}

                                </tr>
                            )
                        })

                        }
                    </tbody>
                </table>
            </div>
            {/*  <Button variant="outlined" onClick={appendFieldArrayData} className='btn1 py-0.5 px-1  float-right mt-1 !bg-green-500  rounded-full'  ><AIcon name="add-circle-outline" size={20} className="text-white" /></Button> */}
        </fieldset>
    )
}

